/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Unpublish_Done_With_PortalsInputs */

const cs_property_unpublish_done_with_portals = /** @type {(inputs: Property_Unpublish_Done_With_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skryto na webu a odebráno z portálů. Portály znovu zapněte na záložce Portály po publikaci.`)
};

const en_property_unpublish_done_with_portals = /** @type {(inputs: Property_Unpublish_Done_With_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden on the website and removed from portals. Re-enable portals on the Portals tab after you publish again.`)
};

/**
* | output |
* | --- |
* | "Hidden on the website and removed from portals. Re-enable portals on the Portals tab after you publish again." |
*
* @param {Property_Unpublish_Done_With_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_unpublish_done_with_portals = /** @type {((inputs?: Property_Unpublish_Done_With_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Unpublish_Done_With_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_unpublish_done_with_portals(inputs)
	return cs_property_unpublish_done_with_portals(inputs)
});